exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-66f1f214] .el-card__body{height:100%;padding-bottom:0!important}[data-v-66f1f214] .custom-height{height:calc(100% - 230px)}.custom-title[data-v-66f1f214]{color:var(--textColor)}[data-v-66f1f214] .upload-label .el-form-item__label{float:none!important}[data-v-66f1f214] .upload-label .el-form-item__content{margin-left:0!important}.required-text--color[data-v-66f1f214]{color:#ff3a30}.down-file--color[data-v-66f1f214]{color:#acdbff}", ""]);

// exports
